const reportImportError = (featureName, error) => {
  if (window.Sentry && typeof window.Sentry.captureException === 'function') {
    window.Sentry.captureException(error, {
      tags: { feature: featureName },
      extra: { message: `Failed to load ${featureName}` }
    });
    return;
  }

  if (window.console && typeof window.console.error === 'function') {
    window.console.error(`Failed to load ${featureName}`, error);
  }
};

const loadFeature = (featureName, importer) => {
  importer().catch(error => reportImportError(featureName, error));
};

const hasHotwireMarkers = () => {
  return !!document.querySelector('turbo-frame, [data-turbo="true"], [data-turbo-frame], [data-controller]');
};

if (window.SENTRY_DSN_FRONTEND) {
  loadFeature('error_tracking', () => import('../features/error_tracking'));
}

if (hasHotwireMarkers()) {
  loadFeature('hotwire', () => import('../features/hotwire'));
}

if (document.querySelector('#washy-app')) {
  loadFeature('washy', () => import('../features/washy'));
}

if (document.querySelector('#hotelSearch')) {
  loadFeature('hotel_search', () => import('../features/hotel_search'));
}

if (document.querySelector('#b2c-persona-carousel-swiper, [data-b2c-slider]')) {
  loadFeature('sliders', () => import('../features/sliders'));
}
